import { useStylesHook } from "../hooks/useStylesHook";
import { TMS_THEME } from "../theming/theming";
import { calculateBorderRadius } from "../styling/borders.styles";
import { calculateDimension, calculateWidth, } from "../styling/dimensions.styles";
import { calculateColor } from "../styling/colors.styles";
export function useViewStyles(props) {
    return useStylesHook({
        view: {
            margin: calculateMarginSize(props?.space),
            marginLeft: calculateMarginSize(props?.spaceLeft),
            marginBottom: calculateMarginSize(props?.spaceBottom),
            marginRight: calculateMarginSize(props?.spaceRight),
            marginTop: calculateMarginSize(props?.spaceTop),
            padding: calculateDimension(props?.padding),
            paddingLeft: calculateDimension(props?.paddingLeft),
            paddingBottom: calculateDimension(props?.paddingBottom),
            paddingRight: calculateDimension(props?.paddingRight),
            paddingTop: calculateDimension(props?.paddingTop),
            border: props?.border
                ? `1px solid ${TMS_THEME.palette.gray.smoke.color}`
                : {},
            borderLeftWidth: calculateBorderWidth(props?.borderWidthLeft, !!props?.border),
            borderBottomWidth: calculateBorderWidth(props?.borderWidthBottom, !!props?.border),
            borderRightWidth: calculateBorderWidth(props?.borderWidthRight, !!props?.border),
            borderTopWidth: calculateBorderWidth(props?.borderWidthTop, !!props?.border),
            backgroundColor: calculateColor(props?.backgroundColor),
            borderRadius: calculateBorderRadius(props?.borderRadius),
            flex: props?.flex ?? {},
            boxShadow: props?.boxShadow ? TMS_THEME.root.boxShadow : {},
            position: props?.position ? props?.position : {},
            ...calculateWidth(props?.width),
            ...getHover(props?.hover),
        },
    });
}
const calculateBorderWidth = (size, border) => {
    if (!border)
        return {};
    switch (size) {
        case "thin":
        case "default":
            return 1;
        case "zero":
            return 0;
        default:
            return border ? 1 : 0;
    }
};
const calculateMarginSize = (size) => {
    if (size === undefined)
        return {};
    if (size === "auto")
        return "auto";
    if (size === "cardZero")
        return -15;
    return calculateDimension(size);
};
const getHover = (color) => {
    if (color === undefined)
        return null;
    return {
        "&:hover": {
            backgroundColor: calculateColor(color),
        },
    };
};
